export const RESET_PASSWORD_INITIAL_FORM_STATE = {
  newPassword: '',
  confirmPassword: '',
};

export const INVALID_FORM = 'invalid-form';
export const INVALID_TOKEN = 'invalid_token';
export const INTERNAL_SERVER_ERROR = 'internal-server-error';
export const TOO_MANY_ATTEMPTS = 'too-many-attempts';
export const PASSWORD_VALIDATION_FAILURE = 'password-validation-failure';
